import React, { useCallback } from "react";

import { MenuItem, TextField, TextFieldProps } from "@mui/material";
import {
  MobileDatePicker as MuiDatePicker,
  DatePickerProps,
} from "@mui/x-date-pickers";
import clsx from "clsx";
import { format } from "date-fns";
import { makeStyles } from "tss-react/mui";

const useStyles = makeStyles()({
  root: {
    "& .MuiInput-root": {
      color: "#1FD4AF",
    },
    "& .MuiSelect-icon": {
      color: "#1FD4AF",
    },
  },
});

function formatValue(date: Date | null, invalidLabel: string) {
  if (date == null) return invalidLabel;

  const isCurrentYear = date?.getFullYear() === new Date().getFullYear();
  const formatString = isCurrentYear ? "EEE, MMM dd" : "EEE, MMM d, yyyy";
  return format(date, formatString);
}

const DatePicker: React.FC<DatePickerProps<Date>> = (props) => {
  const { classes } = useStyles();

  const SelectComponent = useCallback(
    ({ inputRef, ...props }: TextFieldProps) => (
      <TextField {...props} ref={inputRef} select>
        <MenuItem value={props.value as string}>
          {props.value as string}
        </MenuItem>
      </TextField>
    ),
    []
  );

  return (
    <MuiDatePicker
      {...props}
      className={clsx(classes.root, props.className)}
      disablePast
      closeOnSelect
      slotProps={{
        textField: {
          variant: "standard",
          InputProps: { disableUnderline: true },
        },
      }}
      slots={{ textField: SelectComponent }}
    />
  );
};

export default DatePicker;
